
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  computed: {
    width() {
      return (this as any).widthProp ? (this as any).widthProp : "12";
    },
    height() {
      return (this as any).heightProp ? (this as any).heightProp : "21";
    }
  }
})
export default class IcoSiniestro extends Vue {
  @Prop(String) readonly widthProp: string;
  @Prop(String) readonly heightProp: string;
}
